import { AfterContentChecked, AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MapSiteHelper, MapSupervisionHelper } from '@solar/ol';
import * as ol_style from 'ol/style';
import { BaseComponent } from '@solar/shared';
import { SolarService } from '@solar/solar/services/solarservice.service';
import { FrLayer, mapcte } from 'gmap';
import { timer } from 'rxjs';
import { Flight, IssueImage, Site, Supervision } from 'solar-bo';
import { FlightListMapComponent } from '../flight-list-map/flight-list-map.component';

@Component({
  selector: 'app-flight-main',
  templateUrl: './flight-main.component.html',
  styleUrls: ['./flight-main.component.scss']
})
export class FlightMainComponent extends BaseComponent implements OnInit, AfterViewInit,AfterViewChecked {

  site:Site;
  @Input() supervision:Supervision;
  @Output() flightSelectedEvent: EventEmitter<Flight> = new EventEmitter();
  @Output() flightListFilteredEvent: EventEmitter<Flight[]> = new EventEmitter();
  @ViewChild("flightlistmap",{static:true}) flightlistmap: FlightListMapComponent;
  
  showMap: boolean = true;

  constructor(public solarService:SolarService) {
    super();
   }

  ngOnInit(): void {
    this.showMap = true;
  }

  ngAfterViewInit() {    
    let cls = this;
      const source = timer(250);
      const subscribe = source.subscribe(val => {
       
       cls.configMap(cls)
       //this.showMapAsync();
      });    
  }

  ngAfterViewChecked(): void{

  }

  private showMapAsync() {
    let cls = this;
      
      //emit 0 after  complete, since no second argument is supplied
      const source = timer(250);
      const subscribe = source.subscribe(val => {
        cls.configMap(cls)
      });
    
  }

  private configMap(cls:FlightMainComponent) {

    //desactivar capa raster panels
    let map=cls.flightlistmap.mapc;
    map.layerHide(mapcte.RASTERPANELS);
    let site=cls.supervision.site;

    MapSiteHelper.drawSitesOnMap(map, site.name, "sitemarker_" + site.id, [site]);
    map.setZoom(2);

    if (site.geom) {
      let siteLayer = MapSiteHelper.loadSiteGeometry("Site boundary", site.geom, "geom_" + site.id);
      map.layerAdd(siteLayer);
      map.setZoomToExtent(siteLayer);
    }  else if (site.info.location != null) {
      map.setLocation([site.info.location[0], site.info.location[1]] );
      map.setZoom(17);
    } 


    
}

  flightClickedEventHandler($event){
    let item:Flight=$event;
    this.openitem(item);
  }

  openitem(item: Flight) {
      this.flightSelectedEvent.emit(item);
  }

  flighttab_flightSelectedEventHandler(event:{id:any,selected:boolean, flight:Flight, color:any}){

    this.loadFlightImages(event.flight,event.color);
  }
  
  private loadFlightImages(flight: Flight, color:any) {
    

    let map=this.flightlistmap.mapc;
    let parentLayer = map.layerGetByFrid(flight.id);
    if (parentLayer) {
      map.layerShowHide(flight.id);
      return;
    }
    this.loading = true;
    this.flightLayersColors.push({id:flight.id,color:color});
    this.solarService.flightGetImagesCaroussel(flight.id)
      .subscribe(
        res_list => this.loadFlightImagesHandleresult(flight, res_list)
        , err => this.handleError(err)
      );
  }

  private async loadFlightImagesHandleresult(flight: Flight, list: any[]) {
    
    this.map_drawFlightImageProyected(flight,list)
    this.loading = false;
  }
  /**
   * Layers with colors
   */
  private flightLayersColors:any[]=[];





  /**
   * Draw the image for selected issue
   * @param flight 
   * @param image 
   * @param moveto if true move to selected zone
   */
  private map_drawFlightImageProyected(flight: Flight, list: any[]) {
    try {
      let map=this.flightlistmap.mapc;
      let parentLayer = map.layerGetByFrid(flight.id);
      if (!parentLayer) {
        let layerinfo: FrLayer = new FrLayer("Flight: " + flight.name, flight.id);
        parentLayer = map.layerCreateVectorLayer(layerinfo);
        map.layerAdd(parentLayer);
        parentLayer.setStyle(this.mapFlightStyle.bind(this));
        this.flightlistmap.addLayerForToolTip(flight.id);
      }

      let vectorSource = parentLayer.getSource();
      vectorSource.clear();

      let newZoom = map.getZoom();
      for (let issueImageItem of list) {
        let img: IssueImage =issueImageItem;
        img.id_flight=flight.id;
        if (img.geom_polygon != null) {
          let feature=MapSupervisionHelper.imagePolygonDrawNoStyle(img, parentLayer, true);
          //this.flightlistmap.drawprojectedimage(feature);
  /*         let circleFeature = this.map_drawCircle(image.geom_shot.coordinates);
          if (circleFeature) {
            parentLayer.getSource().addFeature(circleFeature);
          } */
        }
      }
      map.setZoomToExtent(parentLayer);
    }
    catch (err) {
      //this.handleError(err);
      this.notifyerror(err, "Error ocurred trying to show the proyected flight image");
    }
  }


  map_imageFillDefault= new ol_style.Fill({
    color: 'rgba(255, 255, 255, 0.01)'
  });

  /**
   * Style for flight
   * @param feature 
   * @param resolution 
   */
  mapFlightStyle(feature, resolution) {

    try {
      //let geom = feature.getGeometry();
      const extInfo: FrLayer = feature.frlayerinfo;
      let flightImage: IssueImage = extInfo.refObject;
  
      
      let title = feature.frlayerinfo.name + " \n " + flightImage.name;
      let scaleSize = 0.9;// Math.floor(resolution * 10000000000);

      let flightColor=this.flightLayersColors.find(item=>item.id==flightImage.id_flight);
      //console.log("color is ", flightColor.color);
      let stroke = new ol_style.Stroke({
        color: flightColor.color,
        width: 1
      });


/*       let textStyle = new ol_style.Text({
        text: title
        , font: 'bold 11px Calibri,sans-serif'
        , scale: scaleSize
        stroke: this.issueNameStroke
      }) */


      let style1 = new ol_style.Style({
        stroke: stroke
        ,fill: this.map_imageFillDefault
      });

      let styles = [style1];

      return styles;
    }
    catch (err) {
      console.log(err);
    }
  }





}
